import React from "react";

interface DisclosuresMltaProps {
    className?: string;
}

const DisclosuresMlta = ({ className = "" }: DisclosuresMltaProps) => {
    const references = [
        {
            number: 1,
            text: "See your contract for specific details.",
        },
        {
            number: 2,
            text: "Coverage subject to eligibility rules and exclusions. See Certificate of Insurance for full details.",
        },
        {
            number: 3,
            text: "Spouse and dependent benefits are based on a percentage of the primary insured’s coverage. Definitions may vary by state.",
        },
        {
            number: 4,
            text: '"Pre- and postinjury financial hardship among trauma survivors: A national survey study," National Center for Biotechnology Information, ',
            link: "https://pubmed.ncbi.nlm.nih.gov/39910712/",
        },
        {
            number: 5,
            text: '"Accidents or Unintentional Injuries," National Center for Health Statistics, ',
            link: "https://www.cdc.gov/nchs/fastats/accidental-injury.htm",
        },
        {
            number: 6,
            text: '"Injuries and Violence Are Leading Causes of Death," Web-based Injury Statistics Query and Reporting System, ',
            link: "https://wisqars.cdc.gov/animated-leading-causes/",
        },
        {
            number: 7,
            text: "Examples of high-risk activities that are not covered include skydiving, rock climbing, motorized racing and similar extreme sports. See policy for full details.",
        },
        {
            number: 8,
            text: "Vehicle-related accidents include cars, buses, motorcycles, bicycles or walking as a pedestrian.",
        },
        {
            number: 9,
            text: "Covered medically prescribed recuperation benefit may be paid up to the same number of days as the covered hospitalization benefit.",
        },
    ];

    return (
        <div id="disclosures" className={`w-full py-6 tablet:py-12 px-6 ${className}`} style={{ backgroundColor: "#F2F1F0" }}>
            <div className="max-w-[1200px] mx-auto">
                <div className="space-y-6">
                    <div className="space-y-3">
                        {references.map((reference) => (
                            <div
                                key={reference.number}
                                id={`disclosure-${reference.number}`}
                                className="flex items-start space-x-3"
                            >
                                <span className="text-base-content font-sans font-medium text-xs tablet:text-sm leading-4 flex-shrink-0">
                                    {reference.number}.
                                </span>
                                <p className="text-base-content font-sans font-medium text-xs tablet:text-sm leading-4 break-words">
                                    {reference.text}
                                    {reference.link && (
                                        <a
                                            href={reference.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 hover:text-blue-800 underline ml-1 break-all"
                                        >
                                            {reference.link}
                                        </a>
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DisclosuresMlta;
